export default __webpack_public_path__ + "static/media/bike2.60c9ea34.png";